import { axiosPrivate } from "../api/axios"
import { useEffect } from 'react'
import useRefreshToken from "./useRefreshToken"
import useAuth from "./useAuth"
import { useNavigate } from "react-router-dom";
import { pState } from "../context/profileContext";
import { snapshot } from "valtio";

const useAxiosPrivate = () => {
    const refresh = useRefreshToken()
    const { Auth } = useAuth()
    const navigate = useNavigate()


    useEffect(
        () => {

            const requestIntercept = axiosPrivate.interceptors.request.use(
                config => {
                    if (!config.headers['Authorization']) {
                        const token = Auth?.accessToken || sessionStorage.getItem('portalToken')
                        if (token) config.headers['Authorization'] = `Bearer ${token}`
                    }
                    
                    // Add clientId from profile to headers
                    const profile = snapshot(pState);
                    if (profile?.clientId) {
                        config.headers['X-Client-Id'] = profile.clientId;
                    }
                    
                    return config
                }, (error) => Promise.reject(error)
            )

            const responseIntercept = axiosPrivate.interceptors.response.use(
                response => response,
                async (error) => {
                    const prevRequest = error?.config;
                    
                    // Handle offline case first
                    if (!navigator.onLine) {
                        return Promise.reject({
                            ...error,
                            response: { data: { message: 'No internet connection' } }
                        });
                    }

                    // Handle case where there's no response (e.g., network error)
                    if (!error.response) {
                        return Promise.reject({
                            ...error,
                            response: { data: { message: 'Network error' } }
                        });
                    }

                    // Check if refresh token fails
                    if (error.response?.config?.url === '/token/refresh') {
                        console.log('Token Refresh Failed');
                        navigate('/loggedout');
                        return Promise.reject(error);
                    }

                    // Handle 403 with token refresh — skip refresh for portal sessions
                    if (error.response?.status === 403 && !prevRequest?.sent) {
                        if (sessionStorage.getItem('portalToken')) {
                            return Promise.reject(error);
                        }
                        try {
                            prevRequest.sent = true;
                            const newAccessToken = await refresh();
                            prevRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                            return axiosPrivate(prevRequest);
                        } catch (refreshError) {
                            // If refresh fails, navigate to logged out
                            navigate('/loggedout');
                            return Promise.reject(refreshError);
                        }
                    }

                    return Promise.reject(error);
                }
            );

            return () => {
                axiosPrivate.interceptors.request.eject(requestIntercept)
                axiosPrivate.interceptors.response.eject(responseIntercept)
            }
        }, [Auth, refresh]
    )

    return axiosPrivate;
}

export default useAxiosPrivate;
